import { createClient, type User as WorkOSUser } from '@workos-inc/authkit-js'

export default defineNuxtPlugin(async () => {
  const {
    public: { workos },
  } = useRuntimeConfig()
  const authUser = useState<WorkOSUser | null>('workos:user', () => null)

  if (!workos.clientId) {
    throw new Error('WORKOS_CLIENT_ID is required')
  }

  const authkit = await createClient(workos.clientId, {
    apiHostname: workos.apiHostname || undefined,
    redirectUri: workos.redirectUri || undefined,
    // On *.up.railway.app (shared preview) the authkit.app session cookie is a
    // blocked third-party cookie, so cookie-based sessions infinite-loop login
    devMode:
      import.meta.dev || window.location.hostname.endsWith('.up.railway.app'),
    onRedirectCallback: ({ state, user }) => {
      authUser.value = user

      const returnTo = useState('workos:return-to', () => '/')
      returnTo.value =
        typeof state?.returnTo === 'string' ? state.returnTo : '/'
    },
    onRefresh: ({ user }) => {
      authUser.value = user
    },
    onRefreshFailure: ({ signIn }) => {
      authUser.value = null
      signIn({ state: { returnTo: window.location.pathname } })
    },
  })

  authUser.value = authkit.getUser()

  return {
    provide: {
      authkit,
    },
  }
})
